import { useEffect, useState } from "react";
import API from "../../../services/api";
import "./uploadResultFile.css";

export default function UploadResultExcel() {
  const school = JSON.parse(localStorage.getItem("schoolAdmin"));

  const [exams,    setExams]    = useState([]);
  const [classes,  setClasses]  = useState([]);
  const [sections, setSections] = useState([]);

  const [examId,    setExamId]    = useState("");
  const [classId,   setClassId]   = useState("");
  const [sectionId, setSectionId] = useState("");
  const [file,      setFile]      = useState(null);
  const [uploading, setUploading] = useState(false);

  useEffect(() => { loadExams(); loadClasses(); }, []);

  const loadExams = async () => {
    const res = await API.get("/school-admin/exams/", {
      headers: { "X-SCHOOL-ID": school.school.id },
    });
    setExams(res.data.exams || []);
  };

  const loadClasses = async () => {
    const res = await API.get("/school-admin/classes/", {
      headers: { "X-SCHOOL-ID": school.school.id },
    });
    setClasses(res.data.classes || []);
  };

  const loadSections = async (cid) => {
    if (!cid) return setSections([]);
    const res = await API.get(`/school-admin/sections/${cid}/`, {
      headers: { "X-SCHOOL-ID": school.school.id },
    });
    setSections(res.data.sections || []);
  };

  const downloadTemplate = () => {
    if (!classId) return alert("Please select a class first");
    const params = new URLSearchParams({
      class:    classId,
      section:  sectionId || "",
      school_id: school.school.id,
    }).toString();
    window.open(
      `${API.defaults.baseURL.replace(/\/$/, "")}/school-admin/results/template/?${params}`,
      "_blank"
    );
  };

  const uploadExcel = async (e) => {
    e.preventDefault();
    if (!examId || !classId || !file) {
      return alert("Exam, Class and Excel file are required");
    }
    const formData = new FormData();
    formData.append("exam", examId);
    formData.append("file", file);
    try {
      setUploading(true);
      await API.post("/school-admin/results/upload-excel/", formData, {
        headers: {
          "X-SCHOOL-ID": school.school.id,
          "Content-Type": "multipart/form-data",
        },
      });
      alert("Results uploaded successfully!");
      setFile(null);
      e.target.reset();
    } catch {
      alert("Upload failed");
    } finally {
      setUploading(false);
    }
  };

  return (
    <div className="urf-page">

      {/* ══ HERO ══ */}
      <div className="urf-hero">
        <div className="urf-hero-left">
          <div className="urf-hero-icon">📊</div>
          <div>
            <h2 className="urf-hero-title">Upload Results (Excel)</h2>
            <p className="urf-hero-sub">Download the template, fill marks, and upload it back</p>
          </div>
        </div>
      </div>

      {/* ══ TEMPLATE DOWNLOAD ══ */}
      <div className="urf-template-box">
        <div className="urf-template-text">
          <p>📥 Download Excel Template</p>
          <small>
            {classId
              ? "Template ready — click to download"
              : "Select a class below first to get the correct template"}
          </small>
        </div>
        <button
          type="button"
          className="urf-btn-template"
          onClick={downloadTemplate}
          disabled={!classId}
        >
          ⬇ Download Template
        </button>
      </div>

      {/* ══ FORM ══ */}
      <form onSubmit={uploadExcel}>

        <div className="urf-card">
          <p className="urf-card-title">Select Exam & Class</p>

          <div className="urf-grid-2">
            <div className="urf-field">
              <label>Exam</label>
              <select value={examId} onChange={e => setExamId(e.target.value)} required>
                <option value="">— Select Exam —</option>
                {exams.map(ex => (
                  <option key={ex.id} value={ex.id}>{ex.name}</option>
                ))}
              </select>
            </div>

            <div className="urf-field">
              <label>Class</label>
              <select
                value={classId}
                onChange={e => {
                  setClassId(e.target.value);
                  setSectionId("");
                  loadSections(e.target.value);
                }}
                required
              >
                <option value="">— Select Class —</option>
                {classes.map(c => (
                  <option key={c.id} value={c.id}>{c.name}</option>
                ))}
              </select>
            </div>

            <div className="urf-field">
              <label>Section <span style={{ fontWeight:400, textTransform:"none" }}>(optional)</span></label>
              <select
                value={sectionId}
                onChange={e => setSectionId(e.target.value)}
                disabled={!classId}
              >
                <option value="">All Sections</option>
                {sections.map(s => (
                  <option key={s.id} value={s.id}>{s.name}</option>
                ))}
              </select>
            </div>
          </div>
        </div>

        <div className="urf-card">
          <p className="urf-card-title">Excel File</p>

          <div className="urf-field urf-grid-1">
            <label>Upload Filled Excel <span style={{ fontWeight:400, textTransform:"none" }}>(.xlsx / .xls)</span></label>
            <div className="urf-file-zone" onClick={() => document.getElementById("excelFile").click()}>
              <div className="urf-file-icon">📊</div>
              <p className="urf-file-hint">Click to browse Excel file</p>
              <p className="urf-file-types">.xlsx · .xls</p>
              {file && <p className="urf-file-chosen">✓ {file.name}</p>}
              <input
                id="excelFile"
                type="file"
                accept=".xlsx,.xls"
                hidden
                onChange={e => setFile(e.target.files[0])}
              />
            </div>
          </div>

          <button
            className="urf-btn-submit"
            type="submit"
            disabled={uploading || !examId || !classId || !file}
          >
            {uploading
              ? <><div className="urf-spinner"></div> Uploading…</>
              : "⬆ Upload Excel Results"
            }
          </button>
        </div>

      </form>
    </div>
  );
}
